import { Component } from '@angular/core';

@Component({
  selector: 'app-line-or-trend-chart',
  template: '<app-chart-output></app-chart-output>'
})
export class LineOrTrendChartComponent {

}
